import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module link/linkimage
 */
import { Plugin } from 'ckeditor5/src/core.js';
import LinkImageEditing from './linkimageediting.js';
import LinkImageUI from './linkimageui.js';
import '../theme/linkimage.css';
/**
 * The `LinkImage` plugin.
 *
 * This is a "glue" plugin that loads the {@link module:link/linkimageediting~LinkImageEditing link image editing feature}
 * and {@link module:link/linkimageui~LinkImageUI link image UI feature}.
 */
var LinkImage = /*#__PURE__*/function (_Plugin) {
  _inherits(LinkImage, _Plugin);
  var _super = _createSuper(LinkImage);
  function LinkImage() {
    _classCallCheck(this, LinkImage);
    return _super.apply(this, arguments);
  }
  _createClass(LinkImage, null, [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [LinkImageEditing, LinkImageUI];
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "pluginName",
    get: function get() {
      return 'LinkImage';
    }
  }]);
  return LinkImage;
}(Plugin);
export { LinkImage as default };